module.exports = __webpack_public_path__ + "img/img-header.92208c7.webp";